/** Evento `beforeinstallprompt` (no incluido en todas las versiones de lib DOM de TS). */
export interface PwaBeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
}

export const PWA_INSTALL_NEVER_KEY = 'pwaInstallNeverShow';
export const PWA_INSTALL_DISMISSED_KEY = 'pwaInstallDismissedSession';
export const PWA_INSTALL_ELIGIBLE_KEY = 'pwaInstallEligibleAfterLogin';

export const PWA_MAIN_SCREEN_PATHS = ['/menu-principal'];

/** SW detectó cambio mientras el usuario no estaba en pantalla principal. */
export const APP_UPDATE_PENDING_CHECK_KEY = 'appPendingVersionCheck';

export const APP_VERSION_CHECK_PENDING_EVENT = 'app-version-check-pending';
